// GAビルド時は REACT_APP_UIUX_RELEASE_ID=uiux-ga-20260901 を指定して上書きする
// （backendの uiux-release.config.js / DBのglobal行と三面一致が必須）。
export const UIUX_THREE_TENANT_PILOT_RELEASE_ID =
    process.env.REACT_APP_UIUX_RELEASE_ID || 'uiux-three-tenant-functional-pilot-20260813-r8';
